module.exports = __webpack_public_path__ + "r-v3/img/user_device_mobile.11472406.svg";